<!--  -->
<template>
  <div class="">
    <div class="top-bg"></div>
    <div class="bottom-bg"></div>
    <maps ref="maps" :zoom="15" @open-device-dialog="openDeviceDialog"></maps>
    <div class="dialog-mask" v-if="dialogQxVisible" @click="closeAllDialogs">
      <div class="dialog-card" @click.stop>
        <div class="dialog-title">气象站</div>
        <div class="dialog-close" @click="closeAllDialogs">×</div>
        <div class="dialog-content text-grid">
          <div>温度: 22℃</div>
          <div>湿度: 70.7%</div>
          <div>空气质量: 44ug</div>
          <div>等级: 2级</div>
          <div>描述: 优良</div>
          <div>风力: 东南风 2级 6km/h</div>
        </div>
      </div>
    </div>
    <div class="dialog-mask" v-if="dialogSqVisible" @click="closeAllDialogs">
      <div class="dialog-card" @click.stop>
        <div class="dialog-title">土壤墒情</div>
        <div class="dialog-close" @click="closeAllDialogs">×</div>
        <div class="dialog-content text-grid" v-if="sqData">
          <div>土壤上层温度: {{ sqData.wd1 }}℃</div>
          <div>土壤上层水分: {{ sqData.sf1 }}%</div>
          <div>土壤中层温度: {{ sqData.wd2 }}℃</div>
          <div>土壤中层水分: {{ sqData.sf2 }}%</div>
          <div>土壤下层温度: {{ sqData.wd3 }}℃</div>
          <div>土壤下层水分: {{ sqData.sf3 }}%</div>
          <div>土壤电导率: {{ sqData.ddl }}</div>
          <div>土壤PH值: {{ sqData.ph }}</div>
        </div>
      </div>
    </div>
    <div class="dialog-mask" v-if="dialogMqVisible" @click="closeMonitorDialog">
      <div class="dialog-card video-card" @click.stop>
        <div class="dialog-title">苗情影像</div>
        <div class="dialog-close" @click="closeMonitorDialog">×</div>
        <div id="mse" class="video-box"></div>
      </div>
    </div>
    <div class="dialog-mask" v-if="dialogCqVisible" @click="closeAllDialogs">
      <div class="dialog-card" @click.stop>
        <div class="dialog-title">虫情</div>
        <div class="dialog-close" @click="closeAllDialogs">×</div>
        <div class="cont" style="background-color: #071f39; width: 800px; height: 480px">
          <div class="cq" style="margin-top: 5px">
            <div class="content flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%99%AB%E6%83%85%E6%B5%8B%E6%8A%A5%E4%BB%AA.png"
                style="width: 270px; height: 440px; margin: 0 10px"
                alt=""
              />
              <div style="flex: 1; margin-right: 20px; margin-left: 40px">
                <div class="flex justb" style="margin-right: 10px; width: 300px">
                  <div class="flex alit cq-right-top-title">运行模式</div>
                  <div class="flex justb" style="flex: 1">
                    <div class="sd" v-if="operatingMode" @click="operatingMode = false">
                      手动
                    </div>
                    <div class="zd" v-else @click="operatingMode = true">自动</div>
                    <div class="paizhao flex alit justc">
                      <img
                        style="width: 21px; height: 17px; margin-right: 10px"
                        src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
                        alt=""
                      />
                      拍照
                    </div>
                  </div>
                </div>
                <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                  <div class="flex alit">
                    <div class="cq-right-top-title">诱虫灯</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value1 ? "开" : "关" }}</div>
                      <el-switch v-model="value1" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                  <div class="flex alit" style="margin-right: 70px">
                    <div class="cq-right-top-title2">虫雨挡板</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value2 ? "开" : "关" }}</div>
                      <el-switch v-model="value2" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                </div>
                <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                  <div class="flex alit">
                    <div class="cq-right-top-title">杀虫挡板</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value3 ? "开" : "关" }}</div>
                      <el-switch v-model="value3" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                  <div class="flex alit" style="margin-right: 70px">
                    <div class="cq-right-top-title2">烘干挡板</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value4 ? "开" : "关" }}</div>
                      <el-switch v-model="value4" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                </div>
                <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                  <div class="flex alit">
                    <div class="cq-right-top-title">移虫装置</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value5 ? "开" : "关" }}</div>
                      <el-switch v-model="value5" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                  <div class="flex alit" style="margin-right: 70px">
                    <div class="cq-right-top-title2">杀虫控制</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value6 ? "开" : "关" }}</div>
                      <el-switch v-model="value6" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-mask" v-if="dialogBzVisible" @click="closeAllDialogs">
      <div class="dialog-card" @click.stop>
        <div class="dialog-title">孢子检测仪</div>
        <div class="dialog-close" @click="closeAllDialogs">×</div>
        <div class="cont" style="background-color: #071f39; width: 800px; height: 480px">
          <div class="cq" style="margin-top: 5px">
            <div class="fout-emotions-title">孢子</div>
            <div class="content flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/a645441470ef28a9f892f3713c55f4b7.png"
                style="width: 230px; height: 400px; margin: 20px"
                alt=""
              />
              <div style="flex: 1; margin-right: 20px; margin-left: 40px">
                <div class="flex justb" style="margin-right: 10px; width: 300px">
                  <div class="flex alit cq-right-top-title">运行模式</div>
                  <div class="flex justb" style="flex: 1">
                    <div class="sd" v-if="operatingMode" @click="operatingMode = false">
                      手动
                    </div>
                    <div class="zd" v-else @click="operatingMode = true">自动</div>
                    <div class="paizhao flex alit justc">
                      <img
                        style="width: 21px; height: 17px; margin-right: 10px"
                        src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
                        alt=""
                      />
                      拍照
                    </div>
                  </div>
                </div>
                <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                  <div class="flex alit">
                    <div class="cq-right-top-title">光源</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value1 ? "开" : "关" }}</div>
                      <el-switch v-model="value1" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                  <div class="flex alit" style="margin-right: 70px">
                    <div class="cq-right-top-title2">吸风风扇</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value2 ? "开" : "关" }}</div>
                      <el-switch v-model="value2" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                </div>
                <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                  <div class="flex alit">
                    <div class="cq-right-top-title">排风风扇</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value3 ? "开" : "关" }}</div>
                      <el-switch v-model="value3" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                  <div class="flex alit" style="margin-right: 70px">
                    <div class="cq-right-top-title2">载波带电机运行</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value4 ? "开" : "关" }}</div>
                      <el-switch v-model="value4" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                </div>
                <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                  <div class="flex alit">
                    <div class="cq-right-top-title">采样电机运行</div>
                    <div class="switch-group">
                      <div class="cq-right-top-status">{{ value5 ? "开" : "关" }}</div>
                      <el-switch v-model="value5" :width="47" active-color="#53c556" inactive-color="#b2b2b2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-mask" v-if="irrigation" @click="closeAllDialogs">
      <div class="irrigation-card" style="position: relative" @click.stop>
        <div class="dialog-close irrigation-close" @click="closeAllDialogs">×</div>
        <irrigation-vue></irrigation-vue>
      </div>
    </div>
    <!-- <div class="group-list" style="top: 200px" @click="openFertilizationAnalysis">施肥分析</div> -->
    <div class="group-list" @click="openGroup">水阀分组</div>
    <div
      class="add-group"
      @click="addGroupMarker"
      v-if="markersTypeId == 2 && !openWaterGroup"
    >
      设置水阀分组
    </div>
    <div
      class="add-group"
      @click="closeWaterGroup"
      v-if="markersTypeId == 2 && openWaterGroup"
    >
      完成水阀分组
    </div>
    <div class="flex alit justb top-data">
      <div class="flexCol alit" style="width: 30%">
        <div class="top-data-text1">
          占地面积<a style="font-size: 14px">(亩)</a>
        </div>
        <div class="top-data-text2">3426.83</div>
      </div>
      <div class="flexCol alit" style="width: 30%">
        <div class="top-data-text1">
          物联设备<a style="font-size: 14px">(台)</a>
        </div>
        <div class="top-data-text2">678</div>
      </div>
      <div class="flexCol alit" style="width: 30%">
        <div class="top-data-text1">
          物资用量<a style="font-size: 14px">(吨)</a>
        </div>
        <div class="top-data-text2">232</div>
      </div>
    </div>
    <div class="flex alit justb bottom-data">
      <div
        class="flexCol alit"
        style="position: relative"
        v-for="item in deviceCount"
        :key="item.title"
      >
        <div
          class="device-list"
          :style="{ backgroundImage: `url(${item.bg})` }"
          @click="getMarkers(item.id)"
        >
          <div class="device-num">
            {{ item.num }} <a style="font-size: 16px" v-if="item.id == 2">套</a
            ><a style="font-size: 16px" v-else>个</a>
          </div>
          <div class="device-title">{{ item.title }}</div>
        </div>
        <img
          class="zhixiang"
          v-if="markersTypeId == item.id"
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%8C%87%E5%90%91%402x.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import maps from "../mapNew.vue";
import irrigationVue from "../irrigation.vue";
import Player from "xgplayer";
import FlvPlugin from "xgplayer-flv";
import "xgplayer/dist/index.min.css";
export default {
  components: { maps, irrigationVue },
  data() {
    return {
      markersTypeId: "",
      openWaterGroup: false,
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      value5: false,
      value6: false,
      operatingMode: true,
      player: null,
      irrigation: false,
      dialogMqVisible: false,
      dialogCqVisible: false,
      dialogSqVisible: false,
      dialogQxVisible: false,
      dialogBzVisible: false,
      sqData: null,
      currentVideoUrl: "",
      deviceCount: [
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E9%98%80%402x.png",
          title: "水阀",
          num: "629",
          id: 2,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E8%82%A5%402x.png",
          title: "水肥机",
          num: "4",
          id: 1,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E8%8B%97%E6%83%85%402x%20%281%29.png",
          title: "苗情检测仪",
          num: "10",
          id: 3,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E8%99%AB%E6%83%85%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "虫情检测仪",
          num: "1",
          id: 7,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E5%A2%92%E6%83%85%402x%20%281%29.png",
          title: "墒情检测仪",
          num: "1",
          id: 5,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%9D%80%E8%99%AB%E7%81%AF.png",
          title: "杀虫灯",
          num: "15",
          id: 8,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%AD%A2%E5%AD%90%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "孢子检测仪",
          num: "1",
          id: 6,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%94%E8%B1%A1%E6%A3%80%E6%B5%8B%E4%BB%AA%402x.png",
          title: "气象站",
          num: "1",
          id: 4,
        },
      ],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    openDeviceDialog(payload = {}) {
      this.closeAllDialogs();
      const { dialogType, sqData, videoUrl } = payload;

      if (dialogType === "irrigation") {
        this.irrigation = true;
        return;
      }

      if (dialogType === "monitor") {
        this.dialogMqVisible = true;
        this.currentVideoUrl = videoUrl || "";
        this.$nextTick(() => {
          this.initMonitorPlayer();
        });
        return;
      }

      if (dialogType === "insect") {
        this.dialogCqVisible = true;
        return;
      }

      if (dialogType === "soil") {
        this.sqData = sqData || null;
        this.dialogSqVisible = true;
        return;
      }

      if (dialogType === "weather") {
        this.dialogQxVisible = true;
        return;
      }

      if (dialogType === "spore") {
        this.dialogBzVisible = true;
      }
    },
    initMonitorPlayer() {
      if (!this.currentVideoUrl) return;
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }

      this.player = new Player({
        id: "mse",
        url: this.currentVideoUrl,
        playsinline: true,
        width: 800,
        height: 450,
        videoInit: true,
        cssFullscreen: true,
        ignores: ["fullscreen"],
        plugins: [FlvPlugin],
        autoplayMuted: true,
        autoplay: true,
      });
    },
    closeMonitorDialog() {
      this.dialogMqVisible = false;
      this.currentVideoUrl = "";
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }
    },
    closeAllDialogs() {
      this.irrigation = false;
      this.dialogCqVisible = false;
      this.dialogSqVisible = false;
      this.dialogQxVisible = false;
      this.dialogBzVisible = false;
      this.sqData = null;
      this.closeMonitorDialog();
    },
    openFertilizationAnalysis(){
      this.$router.push('/fertilizationAnalysis')
    },
    openGroup() {
      this.$refs.maps.closeGroupMarkers();
    },
    closeWaterGroup() {
      this.openWaterGroup = false;
      this.$refs.maps.closeGroupMarkers();
      this.$message({
        message: "暂无操作权限",
        type: "warning",
      });
    },
    //开启水阀分组 点击水阀可进行设置连线
    addGroupMarker() {
      this.$confirm(
        "请按照顺序点击水阀进行分组。 注:已分组水阀不可再次分组",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: false,
          type: "warning",
        }
      )
        .then(() => {
          this.openWaterGroup = true;
          this.$refs.maps.openGroupMarkers();
        })
        .catch(() => {});
    },
    getMarkers(e) {
      this.markersTypeId = e;
      this.$request("iot/device/list?type=" + e).then((res) => {
        this.$refs.maps.setMarkers(res);
      });
    },
    getDeviceCount() {
      this.$request("iot/device/count").then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          // 1水肥 2水阀 3监控 4 气象 5 土壤 6 孢子 7 虫情监测仪 8 虫情灯
          switch (res.data[i].type) {
            case 1:
              // this.deviceCount[1].num = res.data[i].deviceCount;
              break;
            case 2:
              // this.deviceCount[0].num = res.data[i].deviceCount;
              break;
            case 3:
              this.deviceCount[2].num = res.data[i].deviceCount;
              break;
            case 4:
              this.deviceCount[7].num = res.data[i].deviceCount;
              break;
            case 5:
              this.deviceCount[4].num = res.data[i].deviceCount;
              break;
            case 6:
              this.deviceCount[6].num = res.data[i].deviceCount;
              break;
            case 7:
              this.deviceCount[3].num = res.data[i].deviceCount;
              break;
            case 8:
              this.deviceCount[5].num = res.data[i].deviceCount;
              break;
            default:
              break;
          }
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDeviceCount()
    setTimeout(() => {
      this.getMarkers("");
    }, 2000);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {
    this.closeMonitorDialog();
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.dialog-mask {
  position: fixed;
  inset: 0;
  z-index: 2000000;
  background: rgba(0, 0, 0, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-card {
  position: relative;
  min-width: 420px;
  max-width: 860px;
  padding: 22px;
  border-radius: 18px;
  background: #071f39;
  color: #fff;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.34);
  z-index: 999999;
}

.dialog-title {
  font-size: 22px;
  font-weight: 700;
  color: #addaff;
}

.dialog-close {
  position: absolute;
  right: 32px;
  top: 32px;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.dialog-content {
  margin-top: 18px;
  font-size: 16px;
  line-height: 1.8;
}

.text-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(180px, 1fr));
  gap: 10px 18px;
}

.video-card {
  width: 860px;
}

.video-box {
  width: 800px;
  height: 450px;
  margin-top: 16px;
  border-radius: 12px;
  overflow: hidden;
}

.irrigation-card {
  padding-top: 44px;
}

.irrigation-close {
  top: 50px;
  z-index: 99999;
  color: #fff;
}

.cq {
  .sd {
    width: 90px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%89%8B%E5%8A%A8%402x%20%282%29.png");
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  .zd {
    width: 90px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%87%AA%E5%8A%A8%402x%20%281%29.png");
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  ::v-deep .el-switch.is-checked .el-switch__core {
    background-color: rgba(0, 180, 255, 0.4) !important;
    border-color: #53c556 !important;
  }

  ::v-deep .el-switch__core {
    background-color: #a19f9f !important;
  }

  .cq-right-top-title2 {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 2px;
    width: 60px;
  }

  .cq-right-top-title {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 12px;
    width: 60px;
  }

  .switch-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -20px;
  }

  .cq-right-top-status {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 4px;
  }

  .paizhao {
    width: 88px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 20px;
  }
}

.fout-emotions-title {
  height: 38px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A0%87%E9%A2%98%402x%20%281%29.png");
  background-size: 100% 100%;
  font-family: YouSheBiaoTiHei;
  font-size: 20px;
  color: #c4dcf0;
  line-height: 38px;
  padding-left: 30px;
}

.zhixiang {
  width: 58px;
  height: 58px;
  position: absolute;
  bottom: -50px;
}
.group-list {
  width: 130px;
  height: 36px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
  background-size: 100% 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  position: fixed;
  top: 130px;
  right: 100px;
  z-index: 99;
  cursor: pointer;
}
.add-group {
  width: 130px;
  height: 36px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
  background-size: 100% 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  position: fixed;
  top: 130px;
  right: 240px;
  z-index: 99;
  cursor: pointer;
}
.bottom-data {
  position: fixed;
  bottom: 5vh;
  z-index: 99;
  width: 80vw;
  margin-left: 10vw;

  .device-list {
    width: 180px;
    height: 80px;
    background-size: 100% 100%;
    margin-top: 25px;
    cursor: pointer;

    .device-num {
      font-family: DINAlternateBold;
      font-size: 26px;
      color: #ffffff;
      margin: 2px 0 8px 75px;
    }

    .device-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      margin-left: 75px;
    }
  }
}

.top-data {
  width: 36vw;
  position: fixed;
  top: 115px;
  left: 32vw;
  /* z-index: 99; */
  pointer-events: none;

  .top-data-text1 {
    font-weight: 600;
    font-size: 18px;
    color: #addaff;
  }

  .top-data-text2 {
    font-family: YouSheBiaoTiHei;
    font-size: 39px;
    color: #fab040;
  }
}
</style>
